var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOrangeOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13360",
    "data-name": "Group 13360",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.088,
    height: 18.33,
    viewBox: "0 0 26.088 18.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5012",
    "data-name": "Rectangle 5012",
    width: 26.088,
    height: 18.33,
    fill: "#ef7b13"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12745",
    "data-name": "Group 12745",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45354",
    "data-name": "Path 45354",
    d: "M13.051,0A13.829,13.829,0,0,1,25.934,8.473a1.646,1.646,0,0,1,0,1.385A13.421,13.421,0,0,1,15.554,18.1,13.827,13.827,0,0,1,.149,9.866a1.693,1.693,0,0,1,.023-1.44A13.679,13.679,0,0,1,10.345.249a6.716,6.716,0,0,1,.846-.126C11.81.073,12.431.04,13.051,0m-.023,14.381a5.211,5.211,0,1,0-5.2-5.216,5.193,5.193,0,0,0,5.2,5.216",
    transform: "translate(0 0)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45355",
    "data-name": "Path 45355",
    d: "M130.095,80.1a2.622,2.622,0,1,1-2.636,2.592,2.645,2.645,0,0,1,2.636-2.592",
    transform: "translate(-117.039 -73.554)",
    fill: "#ef7b13"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOrangeOpen);
export default __webpack_public_path__ + "static/media/eye-orange-open.24770aa01d8efec43a48b41ce4710d6c.svg";
export { ForwardRef as ReactComponent };